import React from 'react';
import { withRouter } from 'react-router-dom';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
});

const Form = ({
  classes,
  loading,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <TextField
      id="email"
      label="Email"
      required
      fullWidth
      value={values.email}
      onChange={handleChange}
      onBlur={handleBlur}
      margin="normal"
      error={errors.email && touched.email}
      helperText={(touched.email && errors.email) || ' '}
    />
    <Button
      type="submit"
      variant="contained"
      color="primary"
      size="large"
      className={classes.button}
      disabled={loading}
    >
      {loading ? <CircularProgress size={25} color="primary" /> : 'ENVIAR'}
    </Button>
  </form>
);

const ForgotPasswordForm = withFormik({
  mapPropsToValues: props => ({ email: '' }),
  validationSchema: yup.object().shape({
    email: yup
      .string()
      .email()
      .required(),
  }),
  handleSubmit: (values, { props }) => {
    props
      .onResetPassword(values)
      .then(() => {
        let link = '/login';
        if (props.location.state) {
          link = props.location.state.returnLink;
        }
        props.history.push(link);
      })
      .catch(error => error);
  },
})(Form);

export default withRouter(withStyles(styles)(ForgotPasswordForm));
